import BusinessPricing from "../components/business-pricing";
import CollapseEntry from "../components/collapse-entry";
import LeaveModal from "../components/leave_modal";
import AutomizerModal from "../components/automizer-modal";

import "../../sass/pages/_pricing.scss";
import SmoothScroll from "../components/smooth_scroll";
import Pricing from "../components/pricing";
// import TitleBlinking from "../components/title-blinking";
import BarTimer from "../components/bar-timer";
import HiddenPricingABTest from "../components/hidden-pricing-ab-test";
import DetectCurrentUser from "../components/detect-current-user";

export default class PricingPage {
  constructor() {
    const $mainContainer = $("#main");
    if (!$mainContainer.hasClass("pricing-page")) {
      return;
    } else {
      const pricing = new BusinessPricing(".pricing-page", true);

      // if ($('body').hasClass('page-template-template-pricing')) {
      //   const pricing = new Pricing(".pricing-page");
      // } else {
      //   const pricing = new Pricing(".pricing-page", true);
      // }

      const collapse_entry = new CollapseEntry(".collapse-entry");
      const leave_modal = new LeaveModal();
      const automizerModal = new AutomizerModal();
      const smoothScroll = new SmoothScroll();
      const detectCurrentUser = new DetectCurrentUser();

      // if (window.is_xmas_promo_active) {
      //   const titleBlinking = new TitleBlinking(['Get 47% off 🤑', 'It\'s the final sale 🤑'], 700);
      //   const bannerTimer = new BarTimer('.banner-bfpromo__promo-countdown');
      // }

      const hiddenPricingAbTest = new HiddenPricingABTest();
      const testGroup = hiddenPricingAbTest.getGroup();

      if (testGroup) {
        window.location.href = '/start/';
      }
    }
  }
}

$(document).ready(() => {
  const pricingPage = new PricingPage();
});
